import { StylingOption } from '@bluecrew/crew-member-backend-angular-client';

export const getTextStyle = (styling: Array<StylingOption>) => {
  return new Map(styling?.map(obj => [obj.type, obj.value]));
}
